<script lang="ts">
  /**
   * What a list says when it has nothing in it yet — one sentence, an
   * optional glyph above it and an optional action below it — so an empty
   * section still tells the player what will appear there.
   */
  import type { Snippet } from 'svelte';

  interface Props {
    readonly text: string;
    readonly icon?: Snippet | undefined;
    readonly children?: Snippet | undefined;
    readonly testid?: string | undefined;
  }
  const { text, icon, children, testid }: Props = $props();
</script>

<div class="ui-empty" data-testid={testid}>
  {#if icon !== undefined}
    <span class="ui-empty-icon" aria-hidden="true">{@render icon()}</span>
  {/if}
  <p class="ui-empty-text">{text}</p>
  {@render children?.()}
</div>

<style>
  .ui-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: var(--ui-space-2);
    padding: var(--ui-space-4) var(--ui-space-3);
    text-align: center;
    font-family: var(--ui-font);
  }

  .ui-empty-icon {
    display: inline-flex;
    color: var(--ui-ink-2);
  }

  .ui-empty-text {
    margin: 0;
    max-width: 22rem;
    font: var(--ui-text-label);
    line-height: 1.4;
    color: var(--ui-ink-2);
  }
</style>
